import { render, staticRenderFns } from "./EditClusters.vue?vue&type=template&id=9458f32a"
import script from "./EditClusters.vue?vue&type=script&lang=js"
export * from "./EditClusters.vue?vue&type=script&lang=js"
import style0 from "./EditClusters.vue?vue&type=style&index=0&id=9458f32a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports